import { render, staticRenderFns } from "./PHL.vue?vue&type=template&id=295ce80e&scoped=true&"
import script from "./PHL.vue?vue&type=script&lang=js&"
export * from "./PHL.vue?vue&type=script&lang=js&"
import style0 from "./PHL.vue?vue&type=style&index=0&id=295ce80e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295ce80e",
  null
  
)

export default component.exports